import React from "react";
import styled, { withTheme } from "styled-components";
import PropTypes from "prop-types";
import PasswordDigit from "./PasswordDigit";
import PrimaryButton from "../../ui-library/Buttons/PrimaryButton/PrimaryButton";
import { timeConvert } from "../../../modules/constants";
import { useTranslation } from "react-i18next";

const Container = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
`;

const BodyTitle = styled.span`
  color: ${(props) => props.theme?.nero};
  font-weight: 600;
  font-size: 16px;
  margin-top: 27px;
`;

const PasswordContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin-top: 12px;
`;

const UGNXID = styled.span`
  color: ${(props) => props.theme?.darkPurple};
  font-weight: 600;
  font-size: 16px;
  margin-top: 5px;
`;

const ActionButtonsContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  margin-top: 38px;
  @media (max-width: 576px) {
    padding-top: 2rem;
    margin-top: auto;
    .btn {
      width: 100%;
    }
  }
`;

const InfoLabel = styled.p`
  margin-top: 25px;
  color: black;
  font-size: 16px;
`;

const TemporaryPassword = (props) => {
  const { onClose, tempPassword, ugnxId, unlocking, unblocking, expiresIn } =
    props;

  const { t } = useTranslation();

  const passwordExpiresTime = (expiresIn) => {
    if (expiresIn > timeConvert.dayToMinutes) {
      return `${parseInt(expiresIn / timeConvert.dayToMinutes)} ${t(
        "appText.temporary.password.days"
      )}`;
    } else if (expiresIn > timeConvert.hourToMinutes) {
      return `${parseInt(expiresIn / timeConvert.hourToMinutes)} ${t(
        "appText.temporary.password.hours"
      )}`;
    }
    return `${expiresIn} ${t("appText.temporary.password.minutes")}`;
  };

  return (
    <Container data-testid="temporary-password">
      <BodyTitle>{t("appText.temporary.password.header")}</BodyTitle>

      <PasswordContainer>
        {tempPassword?.split("").map((digit, index) => (
          <PasswordDigit key={`digit_${index}`} digit={digit} />
        ))}
      </PasswordContainer>

      <BodyTitle>Caregiver ID</BodyTitle>
      <UGNXID>{ugnxId}</UGNXID>
      {expiresIn && (
        <InfoLabel>
          {t("appText.temporary.password.label.valid", {
            time: passwordExpiresTime(expiresIn),
          })}
        </InfoLabel>
      )}

      {unlocking && (
        <InfoLabel>{t("appText.temporary.password.unlocking")}</InfoLabel>
      )}

      {unblocking && (
        <InfoLabel>{t("appText.temporary.password.unblocking")}</InfoLabel>
      )}

      {onClose && (
        <ActionButtonsContainer>
          <PrimaryButton
            data-testid="temporary-password-close"
            onClick={onClose}
          >
            Close
          </PrimaryButton>
        </ActionButtonsContainer>
      )}
    </Container>
  );
};

TemporaryPassword.defaultProps = {
  onClose: null,
  tempPassword: null,
  ugnxId: null,
};

TemporaryPassword.propTypes = {
  onClose: PropTypes.func,
  tempPassword: PropTypes.string,
  ugnxId: PropTypes.string,
};

export default withTheme(TemporaryPassword);
